import { DATE_FORMAT_DEFAULT } from "@/services/constants/global";
import { formatDate } from "@/services/utils/formatter";
import { Input } from "@chakra-ui/react";
import { enGB, ko } from "date-fns/locale";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

registerLocale("ko", ko);
registerLocale("en", enGB);

export default function DateInputField({
  name = "",
  value,
  setFieldValue = () => {},
  placeholder = "",
  isDisabled = false,
  format = DATE_FORMAT_DEFAULT,
  max = "",
  min = "",
  showYearDropdown,
  showMonthDropdown = true,
  disableKeyboardInput = true,
  ...rest
}) {
  const { t, i18n } = useTranslation();
  const onBlur = () => {
    if (onBlur) onBlur(name, value);
  };

  return (
    <Input
      as={DatePicker}
      locale={i18n.language}
      dateFormat={format}
      maxDate={max}
      minDate={min}
      placeholderText={placeholder || t("YYYY-MM-DD")}
      selected={value}
      onChange={(date) => setFieldValue(name, formatDate(date, format))}
      disabled={isDisabled}
      showMonthDropdown={showMonthDropdown}
      showYearDropdown={showYearDropdown}
      onBlur={onBlur}
      onKeyDown={(e) => disableKeyboardInput && e.preventDefault()}
      // onKeyDown={(e) => e.preventDefault()}
      {...rest}
    />
  );
}
